export const DISTRICT_SET_REIMBURSABLE_MEAL_PRICE = 'DISTRICT_SET_REIMBURSABLE_MEAL_PRICE';
export const DISTRICT_SET_REIMBURSABLE_MEAL_PRICES = 'DISTRICT_SET_REIMBURSABLE_MEAL_PRICES';
export const DISTRICT_SET_REIMBURSABLE_MEAL_PRICES_BY_GRADE = 'DISTRICT_SET_REIMBURSABLE_MEAL_PRICES_BY_GRADE';
export const DISTRICT_SET_MENU_TYPE_PRICING_MODES = 'DISTRICT_SET_MENU_TYPE_PRICING_MODES';
export const DISTRICT_UPDATE_MENU_TYPE_PRICING_MODES = 'DISTRICT_UPDATE_MENU_TYPE_PRICING_MODES';
export const DISTRICT_UPDATE_REIMBURSABLE_MEAL_PRICES = 'DISTRICT_UPDATE_REIMBURSABLE_MEAL_PRICES';
export const DISTRICT_UPDATE_REIMBURSABLE_MEAL_PRICES_BY_GRADE = 'DISTRICT_UPDATE_REIMBURSABLE_MEAL_PRICES_BY_GRADE';
export const SET_LOGS = 'SET_LOGS';
